import * as ReactRouter from 'react-router-dom'
import * as React from 'react'

import * as Common from '@rushplay/common'

import { Divider } from './divider'
import { LiveCasinoCategory } from './live-casino-category'
import { LiveCasinoNavigation } from './live-casino-navigation'

function LiveCasino() {
  return (
    <Common.Box
      flexBasis="0"
      flexGrow="1"
      flexShrink="1"
      overflowX="hidden"
      pt={[1, 2]}
      pb={[5, 2]}
    >
      <ReactRouter.Route path="/live-casino/:gameType?">
        <Common.Box px={[1, 2]} pb={[1, 2]}>
          <LiveCasinoNavigation />
          <Common.Space pt={0}>
            <Divider />
          </Common.Space>
        </Common.Box>
      </ReactRouter.Route>
      <ReactRouter.Switch>
        <ReactRouter.Route path="/live-casino/:category">
          <LiveCasinoCategory />
        </ReactRouter.Route>
      </ReactRouter.Switch>
    </Common.Box>
  )
}

// For @loadable/components
export default LiveCasino
